const API_CALL_STATUS = {
  IDLE: 0,
  FETCHING: 1,
  SUCCESSFUL: 2,
  ERROR: 3,
};

export default API_CALL_STATUS;
